<template>
    <Layout :stylex="{paddingLeft: '320px'}">
        <iframe
            src="/dashboard"
            style="position: absolute; width: 100%; height: 100%; border: none; margin-top: 64px;"
        ></iframe>
    </Layout>
</template>

<script>
export default {
    components: {}
};
</script>